//@ts-nocheck
import React, { useEffect, useState } from 'react'
import { Toaster, toast } from 'sonner'
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { useParams } from 'react-router-dom'

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

function DistributionContainer() {
  const [selectedPlatform, setSelectedPlatform] = useState('')
  const [customValue, setCustomValue] = useState('')
  const [copied, setCopied] = useState(false)
  const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();
  const [baseDetailsData, setBaseDetailsData] = useState('')
  const platforms = [
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'indeed', label: 'Indeed' },
    { value: 'google', label: 'Google Jobs' },
    { value: 'naukri', label: 'Naukri' },
    { value: 'custom', label: 'Custom' }
  ]

  useEffect(() => {
    if (baseId) {
      const fetchData = async () => {
        const storedBaseDetails = localStorage.getItem('baseDetails');
        if (storedBaseDetails) {
          setBaseDetailsData(JSON.parse(storedBaseDetails));

        }
      };
      fetchData();
    }
  }, [baseId]);

  const baseUrl = `https://jobs.teamer.app/${baseDetailsData?.data?.base?.base_slug}/${jobId}`

  const handleCopy = async () => {
    if (!selectedPlatform) {
      toast.error('Please select a platform first')
      return
    }

    if (selectedPlatform === 'custom' && !customValue.trim()) {
      toast.error('Please enter a custom value')
      return
    }

    const sourceValue = selectedPlatform === 'custom' ? customValue.trim() : selectedPlatform
    const urlWithSource = `${baseUrl}?src=${sourceValue}`

    try {
      await navigator.clipboard.writeText(urlWithSource)
      setCopied(true)
      const platformLabel = selectedPlatform === 'custom'
        ? `Custom (${customValue})`
        : platforms && platforms.find(p => p.value === selectedPlatform)?.label
      toast.success(`URL copied for ${platformLabel}`)

      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      toast.error('Failed to copy URL')
    }
  }


  return (
    <>
      <Toaster richColors />
      <div className='h-full'>
        <main className='py-[34px] lg:py-[70px] px-0 lg:px-10 h-full flex'>
          <div className='px-[2px] sm:px-6 lg:px-8 w-full flex justify-center'>
            <div className='w-full max-w-[640px]'>

              <div className='flex flex-col gap-y-1 w-full'>
                <h2 className='text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]'>
               Job Distribution
                </h2>
                <p className='text-sm leading-5 text-[#5c5c5e] font-medium'>
                   Select a platform and copy the job link with the appropriate source parameter
                </p>
              </div>
              <div className='bg-[#e0e0e0] w-full h-[1px] my-8'></div>

              {/* Distribution Form */}
              <div className='space-y-6'>

                <div className='flex items-start gap-x-3 w-full'>
                  <label htmlFor='platform-select' className='text-sm font-medium text-[#1b1b1b] w-[30%] mt-[6px]'>
                    Create job link for -
                  </label>
                  <div className='w-[70%] flex flex-col gap-y-3'>
                    <Listbox value={selectedPlatform} onChange={(value) => {
                      setSelectedPlatform(value)
                      if (value !== 'custom') {
                        setCustomValue('')
                      }
                    }}>
                      <div className="relative z-10">
                        <ListboxButton className="relative w-full rounded-md bg-white py-2 px-[10px] text-left text-gray-900
                                focus:outline-none text-[14px] sm:leading-4 border border-solid border-[#e7e7e8] font-medium cursor-pointer">
                          <div className='flex items-center gap-1.5 justify-between'>
                            <span className="block truncate capitalize">{selectedPlatform || 'Select link'}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                              <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                            </svg>
                          </div>
                        </ListboxButton>
                        <ListboxOptions className="absolute z-10 mt-[9px] left-[0px] bg-white max-w-[100%] min-w-[100%] w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
                          {platforms.length > 0 && platforms.map((platform) => (
                            <ListboxOption
                              key={platform.value} value={platform.value}
                              className={({ active }) =>
                                classNames(
                                  active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                  'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                                )
                              }
                            >
                              <span className="block truncate font-normal">{platform.label}</span>
                            </ListboxOption>
                          ))}
                        </ListboxOptions>
                      </div>
                    </Listbox>
                    {/* Custom Input Field */}
                    {selectedPlatform === 'custom' && (
                      <div className='flex flex-col gap-y-3'>
                        {/* <label htmlFor='custom-input' className='text-sm font-medium text-[#1b1b1b]'>
                      Enter Custom Source Value
                    </label> */}
                        <input
                          id='custom-input'
                          type='text'
                          value={customValue}
                          onChange={(e) => setCustomValue(e.target.value)}
                          placeholder='e.g., facebook, twitter, custom-source'
                          className="block w-full rounded-md border-0 py-1.5 px-2 text-[#121217] text-[14px] font-[500]
              ring-1 ring-inset ring-[#e7e7e8] placeholder:text-[#52555a] 
               focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:leading-6"
                        />
                      </div>
                    )}
                  </div>
                </div>



                {selectedPlatform && (
                  <div className='bg-[#f8f9fa] border border-[#e9ecef] rounded-lg p-4'>
                    <div className='flex flex-col gap-y-2'>
                      <span className='text-sm font-medium text-[#495057]'>Generated URL:</span>
                      <div className='flex items-center gap-2 w-full'>
                        <div className='flex items-center gap-2 p-2 bg-white border rounded-md w-[75%]'>
                          <code className='flex-1 text-sm text-[#6c757d] line-clamp-1'>
                            {baseUrl}?src={selectedPlatform === 'custom' ? (customValue || 'your-custom-value') : selectedPlatform}
                          </code>
                        </div>
                        <button
                          onClick={handleCopy}
                          disabled={!selectedPlatform || (selectedPlatform === 'custom' && !customValue.trim())}
                          className={` inline-flex shrink-0  justify-center py-[7px] rounded-md gap-x-2 w-[25%] items-center px-[14px] 
                     text-[13px] font-medium h-full leading-6 shadow-sm  focus-visible:outline focus-visible:outline-2 
                    focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${selectedPlatform && (selectedPlatform !== 'custom' || customValue.trim())
                              ? 'bg-indigo-600 hover:bg-indigo-500 text-white'
                              : 'bg-[#e0e0e0] text-[#a0a0a0] cursor-not-allowed'
                            }`}
                        >

                          {copied ? (
                            <>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-check w-[1rem] h-[1rem] text-[#fff]"
                              >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M5 12l5 5l10 -10" />
                              </svg>

                              Copied!
                            </>
                          ) : (
                            <>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-copy w-[1rem] h-[1rem] text-[#fff]"
                              >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
                                <path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
                              </svg>

                              Copy Link
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  )
}

export default DistributionContainer